<template>

</template>
<script>

export default {

	data() {
		return {
			form: this.newForm({
				email: "",
			}),
		};
	},

	methods: {
		async submit() {
			this.form.processing = true;
			await this.$client("auth").get("sanctum/csrf-cookie");
			await this.form.post("sign-up/resend-confirmation-email").then(() => {
				this.$router.push({name: "register.confirm"});
				this.$store.dispatch("alertsStore/success", "Please check your emails");
			}).catch(error => {
				if ("AccountUnconfirmed" === error.response.data.error) {
					this.$router.push({name: "register.confirm"});
				}
			});
		},
	},
};
</script>
